import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Paper,
  Skeleton,
  Typography,
} from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import type { VoiceAssistantPreviewSection } from "../../api/voiceSettings";

function sectionRows(section: VoiceAssistantPreviewSection) {
  if (section.id === "business_identity") {
    return [
      ["Business name", section.content.business_name],
      ["Description", section.content.business_description],
    ];
  }
  return [
    ["Style", section.content.style_label],
    ["Chat greeting", section.content.chat_greeting || "Default greeting"],
    ["Voice greeting", section.content.voice_greeting || "Default greeting"],
    ["Extra guidance", section.content.extra_guidance || "None"],
  ];
}

export function VoiceAssistantPreview({
  sections,
  loading,
}: {
  sections: VoiceAssistantPreviewSection[] | null;
  loading: boolean;
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: "14px",
        border: "1px solid #E2E8F0",
        backgroundColor: "#fff",
      }}
    >
      <Typography sx={{ fontWeight: 700, color: "#0F172A", mb: 0.75 }}>
        Assistant preview
      </Typography>
      <Typography sx={{ fontSize: "0.84rem", color: "#64748B", mb: 2 }}>
        Preview the business identity and assistant style that Setin will use.
      </Typography>

      {loading && (
        <Box>
          <Skeleton variant="rectangular" height={48} sx={{ mb: 1 }} />
          <Skeleton variant="rectangular" height={48} />
        </Box>
      )}

      {!loading && !sections && (
        <Typography sx={{ fontSize: "0.86rem", color: "#64748B" }}>
          Select Preview assistant to load a safe preview.
        </Typography>
      )}

      {!loading &&
        sections?.map((section) => (
          <Accordion
            key={section.id}
            defaultExpanded={!section.collapsed_by_default}
            disableGutters
            elevation={0}
            sx={{
              border: "1px solid #E2E8F0",
              borderRadius: "10px",
              mb: 1,
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreRoundedIcon />}>
              <Typography sx={{ fontWeight: 600, color: "#0F172A" }}>
                {section.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 0 }}>
              {sectionRows(section).map(([label, value]) => (
                <Box key={label} sx={{ mb: 1.5 }}>
                  <Typography
                    sx={{ fontSize: "0.72rem", color: "#94A3B8", mb: 0.4 }}
                  >
                    {label}
                  </Typography>
                  <Typography sx={{ fontSize: "0.88rem", color: "#334155" }}>
                    {value || "Not set"}
                  </Typography>
                </Box>
              ))}
            </AccordionDetails>
          </Accordion>
        ))}
    </Paper>
  );
}
